export const GUADELOUPE_CITIES = [
    { name: "Anse-Bertrand", postalCode: "97121" },
    { name: "Baie-Mahault", postalCode: "97122" },
    { name: "Baillif", postalCode: "97123" },
    { name: "Basse-Terre", postalCode: "97100" },
    { name: "Bouillante", postalCode: "97125" },
    { name: "Capesterre-Belle-Eau", postalCode: "97130" },
    { name: "Capesterre-de-Marie-Galante", postalCode: "97140" },
    { name: "Deshaies", postalCode: "97126" },
    { name: "Gourbeyre", postalCode: "97113" },
    { name: "Goyave", postalCode: "97128" },
    { name: "Grand-Bourg", postalCode: "97112" },
    { name: "La Désirade", postalCode: "97127" },
    { name: "Lamentin", postalCode: "97129" },
    { name: "Le Gosier", postalCode: "97190" },
    { name: "Le Moule", postalCode: "97160" },
    { name: "Les Abymes", postalCode: "97139" },
    { name: "Morne-à-l'Eau", postalCode: "97111" },
    { name: "Petit-Bourg", postalCode: "97170" },
    { name: "Petit-Canal", postalCode: "97131" },
    { name: "Pointe-à-Pitre", postalCode: "97110" },
    { name: "Pointe-Noire", postalCode: "97116" },
    { name: "Port-Louis", postalCode: "97117" },
    { name: "Saint-Claude", postalCode: "97120" },
    { name: "Saint-François", postalCode: "97118" },
    { name: "Saint-Louis", postalCode: "97134" },
    { name: "Sainte-Anne", postalCode: "97180" },
    { name: "Sainte-Rose", postalCode: "97115" },
    { name: "Terre-de-Bas", postalCode: "97136" },
    { name: "Terre-de-Haut", postalCode: "97137" },
    { name: "Trois-Rivières", postalCode: "97114" },
    { name: "Vieux-Fort", postalCode: "97141" },
    { name: "Vieux-Habitants", postalCode: "97119" }
  ];  